import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { usePlanTrialOptInModal } from "@/react/components/SettingsApp/Plan/PlanTrialOptInModal";
import { planTiers } from "@/react/helpers/planHelpers";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { useShouldShowPlanTrial } from "@/react/hooks/useShouldShowPlanTrial";

export const PlanTrialOptInBanner = () => {
  const planTrialOptInModal = usePlanTrialOptInModal();
  const { trackEvent } = useEventsTracker();
  const shouldShowBanner = useShouldShowPlanTrial();

  if (!shouldShowBanner) {
    return null;
  }

  const handleStartTrial = () => {
    trackEvent("plan_trial_opt_in_banner.clicked", {
      page: "plan_settings",
    });
    void planTrialOptInModal.show({
      planTier: planTiers.business,
      trialType: "business_thirty_day",
      onConfirm: () => {
        trackEvent("plan_trial_opt_in_modal.trial_started", {
          page: "plan_settings",
        });
      },
      onCancel: () => {
        trackEvent("plan_trial_opt_in_modal.cancelled", {
          page: "plan_settings",
        });
      },
    });
  };

  return (
    <div className="dark:border-primary mb-4 rounded-md border border-blue-200 bg-gradient-to-b from-white to-[#F1F6FF] p-4 dark:bg-gradient-to-b dark:from-gray-800 dark:to-gray-900">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 shrink-0">
          <div className="flex size-10 items-center justify-center">
            <Icon
              type="16-star-fill"
              size={16}
              className="text-blue-600 dark:text-blue-400"
              useWithFillCurrentColor
            />
          </div>
        </div>
        <div className="flex-1">
          <div className="mb-1">
            <Typography.LabelMd weight="bold">
              {t("settings.billing.plans.trial_opt_in_banner.title")}
            </Typography.LabelMd>
          </div>
          <div className="mb-3">
            <Typography.BodySm color="text-light">
              {t("settings.billing.plans.trial_opt_in_banner.description")}
            </Typography.BodySm>
          </div>
          <Button variant="secondary" onClick={handleStartTrial}>
            {t("settings.billing.plans.trial_opt_in_banner.cta")}
          </Button>
        </div>
      </div>
    </div>
  );
};
